import { httr } from "./httr/client.mjs";
export const r = {
    info: {
        key: 'r',
        title: 'R',
        extname: '.r',
        default: 'httr',
    },
    clientsById: {
        httr,
    },
};
